export const tr = {
    emptyPrice: 'belirtilmedi'
};
